import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { MenuItem, Select } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import DyanmicFromMobile from "../../DyanmicForm/DyanmicFromMobile";
import DeletePop from "../../../constants/ErrorPermissionModal";
import ActionMobileDrop from "../../ActionDropBar/ActionMobileDrop";

const SailingMenuInput = ({ data, setData }) => {
  const [sailingPage, setSailingPage] = useState();
  const [activeRow, setActiveRow] = useState(0); // 👈 track which row is active

  const handleChange = (index, field, value) => {
    const updatedRows = [...data.rows];
    updatedRows[index][field] = value;
    setData({ ...data, rows: updatedRows });
  };

  const addRow = () => {
    setData({
      ...data,
      rows: [
        ...data.rows,
        {
          english_menu: "",
          simplified_chinese_menu: "",
          traditional_chinese_menu: "",
          day: {
            english: "",
            simplified_chinese: "",
            traditional_chinese: "",
          },
        },
      ],
    });
    setActiveRow(data.rows.length); // 👈 open new row automatically
  };

  const getMenuTitle = (day) => {
    if (!day || typeof day !== "object") return "Menu Title";
    const name =
      day?.english?.trim() ||
      day?.simplified_chinese?.trim() ||
      day?.traditional_chinese?.trim() ||
      "";

    return name ? `Menu Title ${name}` : "Menu Title";
  };


  useEffect(() => {
    setSailingPage(JSON.parse(localStorage.getItem("sailing-page") || "{}"));
  }, []);

  let remark = [
    {
      title: "English Menu",
      key: "english_menu",
      className: "col-lg-4",
      type: "file",
      placeholder: "Upload English Menu",
      filetype: "pdf",
      required: false,
    },
    {
      title: "Simplified Chinese Menu",
      key: "simplified_chinese_menu",
      className: "col-lg-4",
      placeholder: "Upload Simplified Chinese Menu ",
      type: "file",
      filetype: "pdf",
      required: false,
    },
    {
      title: "Traditional Chinese Menu",
      key: "traditional_chinese_menu",
      className: "col-lg-4",
      placeholder: "Upload Traditional Chinese Menu ",
      type: "file",
      filetype: "pdf",
      required: false,
    },
  ];

  const deleteRow = (index) => {
    if (data.rows.length > 0) {
      const updatedRows = data.rows.filter((_, i) => i !== index);
      setData({ ...data, rows: updatedRows });
      if (activeRow === index) setActiveRow(null); // 👈 close if deleted
    }
  };

  return (
    <div style={{}} className="col-12 row ">
      {data?.rows?.map((row, index) => (
        <div
          key={index}
          className="row col-12"
          style={{
            display: "flex",
            marginLeft: "10px",
            alignItems: "center",
            padding: "10px",
            border: "1px solid black",
            marginBottom: "15px",
            borderRadius: "10px",
          }}
        >
          {activeRow === index ? (
            <div
              className="col-lg-12 fieldrow "
              // 👈 click to activate row
              style={{ cursor: "pointer" }}
            >
              <div
                style={{
                  borderBottom: "1px solid black",
                  paddingBottom: "10px",
                }}
              >
                <ActionMobileDrop
                  title={getMenuTitle(row?.day)}
                  active={activeRow === index}
                  setActive={() => setActiveRow()}
                  handleDelete={() => deleteRow(index)}
                />
              </div>

              {/* English Title */}
              <div className="row col-12">
                <div
                  className="col-md-4 col-sm-12 col-4"
                  style={{ marginBottom: "20px" }}
                >
                  <label>English Title</label>
                  <input
                    type="text"
                    style={{
                      width: "100%",
                      height: "45px",
                      padding: "0 10px",
                      fontSize: "16px",
                      boxSizing: "border-box",
                    }}
                    value={row?.day?.english || ""}
                    required
                    onChange={(e) =>
                      handleChange(index, "day", {
                        ...row.day,
                        english: e.target.value,
                      })
                    }
                    disabled={activeRow !== index}
                  />
                </div>

                {/* Simplified Chinese Title */}
                <div
                  className="col-md-4 col-sm-12 col-4"
                  style={{ marginBottom: "20px" }}
                >
                  <label>Simplified Chinese Title</label>
                  <input
                    type="text"
                    style={{
                      width: "100%",
                      height: "45px",
                      padding: "0 10px",
                      fontSize: "16px",
                      boxSizing: "border-box",
                    }}
                    value={row?.day?.simplified_chinese || ""}
                    required
                    onChange={(e) =>
                      handleChange(index, "day", {
                        ...row.day,
                        simplified_chinese: e.target.value,
                      })
                    }
                    disabled={activeRow !== index}
                  />
                </div>

                {/* Traditional Chinese Title */}
                <div
                  className="col-md-4 col-sm-12 col-4"
                  style={{ marginBottom: "20px" }}
                >
                  <label>Traditional Chinese Title</label>
                  <input
                    type="text"
                    style={{
                      width: "100%",
                      height: "45px",
                      padding: "0 10px",
                      fontSize: "16px",
                      boxSizing: "border-box",
                    }}
                    value={row?.day?.traditional_chinese || ""}
                    required
                    onChange={(e) =>
                      handleChange(index, "day", {
                        ...row.day,
                        traditional_chinese: e.target.value,
                      })
                    }
                    disabled={activeRow !== index}
                  />
                </div>
              </div>
              
              <DyanmicFromMobile
                error={[]}
                rootData={data}
                level={1}
                attributes={remark || []}
                data={row["menu"] || {}}
                setData={(e) => {
                  handleChange(index, "menu", e);
                }}
              />
            </div>
          ) : (
            <div
              className="col-lg-12"
              style={{ fontSize: "18px ", fontWeight: "bold" }}
            >
              <ActionMobileDrop
                // title={`Menu Date ${row?.day || ""}`}
                title={getMenuTitle(row?.day)}
                active={activeRow === index}
                setActive={() => setActiveRow(index)}
                handleDelete={() => deleteRow(index)}
              />
            </div>
          )}

          {/* <div className="col-2">
           
            <DeletePop onConfirm={() => deleteRow(index)}>
              <RemoveCircleOutlineIcon
                type="button"
                style={{
                  borderRadius: "50%",
                  width: "35px",
                  background: "white",
                  height: "35px",
                  cursor: data.rows.length > 1 ? "pointer" : "not-allowed",
                  color: data.rows.length > 1 ? "red" : "grey",
                  fontSize: "18px",
                }}
              />
            </DeletePop>
          </div> */}
        </div>
      ))}
      <button
        type="button"
        onClick={addRow}
        style={{ maxWidth: "100px", marginLeft: "10px" }}
        className="btn main_submit"
      >
        Add Item
      </button>
      {/* {
        <AddCircleOutlineIcon
          onClick={addRow}
          type="button"
          style={{
            borderRadius: "50%",
            width: "35px",
            background: "white",
            height: "35px",
            cursor: "pointer",
            color: "green",
            fontSize: "18px",
          }}
        />
      } */}
    </div>
  );
};

export default SailingMenuInput;
